import { Icon } from "@repo/ping-design";
import cx from "classnames";
import { memo } from "react";

import "./BuildingsListButton.scss";

export type BuildingsListButtonProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick: () => void;
  isOpen: boolean;
};

export const BuildingsListButton = memo(
  ({ className, style, onClick, isOpen }: BuildingsListButtonProps) => {
    const appliedClasses = cx(
      "BuildingsListButton",
      {
        "BuildingsListButton--Open": isOpen,
      },
      className,
    );

    return (
      <button className={appliedClasses} style={style} onClick={onClick}>
        <span className="BuildingsListButton__ItemsContainer">
          <Icon
            iconName="Table2"
            className="BuildingsListButton__Icon"
          />
          <p>List View</p>
          <Icon
            iconName={isOpen ? "ChevronsDown" : "ChevronsUp"}
            className="BuildingsListButton__Icon"
          />
        </span>
      </button>
    );
  },
);

BuildingsListButton.displayName = "BuildingsListButton";
